// components/EtimesgutSidebar.jsx

import React from "react";
import { Link, useLocation } from "react-router-dom";

const serviceAreas = [
  {
    label: "Bağlıca Halı Yıkama",
    path: "/etimesgut/baglica-hali-yikama",
    description:
      "Bağlıca bölgesinde halılarınız modern makinelerde, çevre dostu ürünlerle yıkanır. Ücretsiz servis ve zamanında teslimat garantisi sunuyoruz."
  },
  {
    label: "Eryaman Halı Yıkama",
    path: "/etimesgut/eryaman-hali-yikama",
    description:
      "Eryaman’a özel halı yıkama hizmetimizde hijyen, kalite ve müşteri memnuniyeti ön plandadır. Antibakteriyel ürünlerle güvenli temizlik sağlanır."
  },
  {
    label: "Elvankent Halı Yıkama",
    path: "/etimesgut/elvankent-hali-yikama",
    description:
      "Elvankent’te profesyonel ekiplerimiz halılarınızı evinizden alır, hijyenik ortamda yıkar ve steril paketleme ile geri teslim eder."
  },
  {
    label: "Etimesgut Tüm Semtler",
    path: "/etimesgut/tum-semtler",
    description:
      "Etimesgut’un tüm mahallelerine hızlı, ekonomik ve kaliteli halı yıkama hizmeti sunuyoruz. Geniş servis ağımızla kapıdan alım ve teslimat yapıyoruz."
  }
];


const EtimesgutSidebar = () => {
  const location = useLocation();

 
   return (
     <div className="mt-2 text-[#003132]">
         <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">ETİMESGUT SERVİS ALANLARI</h2>
 
       <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
         {serviceAreas.map((area, index) => (
           <div key={index}>
             <Link
               to={area.path}
               className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                 location.pathname === area.path
                   ? "bg-red-600 text-white"
                   : "text-red-900 hover:bg-green-100 hover:text-red-800"
               }`}
             >
               {area.label}
             </Link>
             <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
           </div>
         ))}
       </div>
     </div>
   );
 };

export default EtimesgutSidebar;
